<div *ngIf="config && queryParams">
  <sblib
    [loadOptions]="{ siteConfiguration: config, siteParams: queryParams }"
  ></sblib>
  <app-cookies-center></app-cookies-center>
</div>
